<div data-cy="context-detail__page" class="row popup-container sidebar-modal">
    <div class="popup-header row no-margin">
        <div class="col-xs-12 mb-5">
            <app-breadcrumb data-cy="context-detail__breadcrumb"></app-breadcrumb>
            <button data-cy="context-detail__close-btn" type="button" class="close no-margin" (click)="close()"
                matTooltip="{{ 'close' | transloco | capitaliz }}">
                <span aria-hidden="true">
                    <mat-icon class="d-text-middle uil uil-multiply"></mat-icon>
                </span>
                <span class="sr-only">Close</span>
            </button>
            <div *ngIf="!isLoading && context?.is_relevant">
                <mat-icon data-cy="context-detail__delete-context" class="d-cursor-hand uil uil-trash delete pull-right context-delete"
                    matTooltip="{{ 'delete' | transloco | capitaliz }}" (click)="deleteContext()">
                </mat-icon>
            </div>
        </div>
        <div class="col-xs-12 popup-header-title">
            <h1><strong>{{ 'contexts.label' | transloco | capitaliz }} </strong>{{ context?.text }}</h1>
        </div>
    </div>

    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <div class="popup-body" appScroll *ngIf="!isLoading && context">

        <!-- left col -->
        <div class="col-md-7 col-xs-12">
            <h3>{{ 'decisions.connections' | transloco | capitaliz }}</h3>
            <div class="col-xs-12 panel z-depth-2 panel-border panel-border-relation-component">
                <div>
                    <mat-progress-bar *ngIf="!loaded" mode="buffer"></mat-progress-bar>
                    <app-add-connect-generic data-cy="context-detail__add-connect-generic" 
                        *ngIf="loaded" 
                        parentType="contexts" 
                        [isReadOnly]="false" 
                        (onChange)="updateEntitiesFromGeneric($event)" 
                        [parent]="context" 
                        [data]="entities" 
                        [types]="['stakeholders','permits','issues','requirements','contactmoments','documents']">
                    </app-add-connect-generic>
                </div>
            </div>
        </div>

        <!-- right col -->
        <div class="col-md-5 col-xs-12">
            <h3>{{ 'text.general' | transloco | capitaliz }}</h3>
            <div class="col-xs-12 panel z-depth-2 panel-border">
                <mat-form-field class="col-xs-12 full-width">
                    <mat-label>{{ 'contexts.label' | transloco | capitaliz }} {{ 'settings.name' | transloco | lowercase }}</mat-label>
                    <input data-cy="context-detail__text-input" matInput type="text" name="text" [(ngModel)]="context.text" (blur)="updateEntities()" required/>
                </mat-form-field>

                <mat-form-field class="col-xs-12 full-width">
                    <mat-label>{{ 'reusable.description' | transloco }}</mat-label>
                    <textarea data-cy="context-detail__description-input" matInput name="description" [(ngModel)]="context.description" (blur)="updateEntities()" rows="3" required></textarea>
                </mat-form-field>

                <div class="col-xs-12">
                    <app-generic-uniselect 
                        [placeholder]="'type' | transloco | capitaliz" 
                        [selectedValue]="context.types" 
                        (onThemeSelected)="onSelectTheme($event)" 
                        [items]="types" 
                        [uniqueId]="'context-type'">
                    </app-generic-uniselect>
                </div>
            </div>
        </div>
    </div>
</div>
